import { type To, useNavigation, useResolvedPath } from "react-router-dom";

/**
 * Whether `to` is being opened and hasn't arrived, as while its screen's code downloads. It
 * reads only the router's navigation, so a link knows nothing about the network. Never, without
 * a `to`, for a component that is a link only sometimes.
 */
export const useIsOpening = (to: To | undefined) => {
    const navigation = useNavigation();
    const { pathname } = useResolvedPath(to ?? ".");

    return to !== undefined && navigation.state === "loading" && navigation.location.pathname === pathname;
};
